export default __webpack_public_path__ + "static/media/filter-blue.87bc71cb.svg";